import { PROGRAM_ADS_ITEMS, PROGRAM_HIGHLIGHTS, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CINEMAS, ROUTES_DATA, PROGRAM_PERFORMANCES, CLI_MULTICINEMA_MODE } from "../../../constants/state"
import getData from "../../../functions/getData"
import mergeWpState from "../../../functions/mergeWpState"


const getNewsletterRawData = (campaignId, hasAll=false) => state => ({
    weeks: state.getIn(['newsletterServerData', 'weeks']),
    week: state.getIn(['newsletterLocalData', 'newsletters', 'items', campaignId, 'currentWeek']),
    themeData: mergeWpState(state, 'data').getIn(['theme']),
    logoData: mergeWpState(state, 'data').getIn(['logo']),
    addressData: mergeWpState(state, 'data').getIn(['cinema']),
    socialMediaData: mergeWpState(state, 'data').getIn(['socialmedia']),
    cinemasData: getData(state, PROGRAM_CINEMAS),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    campaign: state.getIn(['newsletterServerData', 'campaigns', 'data', 'items', campaignId]),
    ... hasAll && {campaigns: state.getIn(['newsletterServerData', 'campaigns', 'data', 'items'])},
    ... hasAll && {newsletterData: state.getIn(['newsletterLocalData', 'newsletters', 'items', 'all', 'items'])},
    ... !hasAll && {newsletterData: state.getIn(['newsletterLocalData', 'newsletters', 'items', campaignId, 'items'])},
    ads: getData(state, [PROGRAM_ADS_ITEMS]),
    highlights: getData(state, [PROGRAM_HIGHLIGHTS]),
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    routeMovies: state.getIn([ROUTES_DATA, 'movies', 'items']),
    allPerformances: getData(state, PROGRAM_PERFORMANCES),
    textItems: state.hasIn(['newsletterLocalData', 'texts', 'items']) ? state.getIn(['newsletterLocalData', 'texts', 'items']) : null,
    imageItems: state.hasIn(['newsletterLocalData', 'images', 'items']) ? state.getIn(['newsletterLocalData', 'images', 'items']): null,
    currentCinemaUrl: mergeWpState(state, 'data').getIn(['site', 'url_site']),
    routesData: getData(state, ROUTES_DATA),
    closingTextLines: mergeWpState(state, 'data').getIn(['features', 'newsletter_closing_formula']),
    translation: state.get('translation')
})


export default getNewsletterRawData